import API from './api.js';

const authHeaders = (token) => ({ Authorization: `Bearer ${token}` });

export const getVideoNewsChannels = async (token) => {
  const response = await API.get('/admin/video-news/channels', {
    headers: authHeaders(token),
  });
  return response.data;
};

export const createVideoNewsChannel = async (data, token) => {
  const response = await API.post('/admin/video-news/channels', data, {
    headers: authHeaders(token),
  });
  return response.data;
};

export const updateVideoNewsChannel = async (id, data, token) => {
  const response = await API.put(`/admin/video-news/channels/${id}`, data, {
    headers: authHeaders(token),
  });
  return response.data;
};

export const deleteVideoNewsChannel = async (id, token) => {
  const response = await API.delete(`/admin/video-news/channels/${id}`, {
    headers: authHeaders(token),
  });
  return response.data;
};

export const syncVideoNewsNow = async (token, channelId = null) => {
  const response = await API.post(
    '/admin/video-news/sync-now',
    channelId ? { channelId } : {},
    { headers: authHeaders(token) }
  );
  return response.data;
};
